// CustomHeaders.js
import { formatDateWithAmPm, getStatusClass } from "../../Style";

export const customHeaders = (page) => [
  {
    field: "customerId",
    header: "Customer Id",
    isClickable: true,
    // onClick: (row) => {
    //   return `/customers/view/${row.id}`;
    // },
    onClick: (row) => ({
      pathname: `/customers/view/${row.id}`,
      state: { page: page }, // 👈 extra state
    }),
  },
  {
    field: "full_name",
    header: "Full Name",

    sortable: true,
  },
  { field: "email", header: "Email" },
  { field: "mobile", header: "Mobile" },
  { field: "booking_count", header: "Booking Count" },
  {
    field: "lastActive",
    header: "Last Active",
    render: (value) => formatDateWithAmPm(value),
  },
  {
    field: "createdDate",
    header: "Created Date",
    render: (value) => formatDateWithAmPm(value),
    sortable: true,
  },
  {
    field: "updatedDate",
    header: "Updated Date",
    render: (value) => formatDateWithAmPm(value),
    sortable: true,
  },
  {
    field: "status",
    header: "Status",
    render: (value) => (
      <span className={`badge ${getStatusClass(value)}`}>{value}</span>
    ),
  },
];
